export const MEDIA_STATUS = {
  active: 1,
  inactive: 2,
};


/**
 * IKON Guest's media e.g. a season pass.
 */
export type Media = {
  mediaID: string,
  chipID?: string,
  statusCode: number,
  printDate: string,
}

/**
 * An empty media object -- fulfilling the 'identity element' part of a monoid.
 */
export const EMPTY_MEDIA: Media = {
  mediaID:    '',
  chipID:     '',
  statusCode: MEDIA_STATUS.active,
  printDate:  new Date().toISOString(),
};